import React from "react";
import { styled } from "@material-ui/styles";
import { IStyledArguments } from "../../../types/styled-arguments";

const ImageHeader = styled("div")(({ theme }: IStyledArguments) => ({
  padding: theme.spacing(0, 1, 1, 1),
  width: "100%",
}));

const ImageHeaderComponent = () => (
  <ImageHeader>
    <svg
      id="_x33_0"
      enableBackground="new 0 0 64 64"
      height="70px"
      viewBox="0 0 64 64"
      width="70px"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <linearGradient
        id="SVGID_1_"
        gradientUnits="userSpaceOnUse"
        x1="32"
        x2="32"
        y1="63"
        y2="1"
      >
        <stop offset="0" stopColor="#FF5722" />
        <stop offset="1" stopColor="#0bb1d3" />
      </linearGradient>
      <path
        d="m32 63c2.79 0 5.313-1.151 7.129-3h16.871v-53h-13.153l-1-6h-19.694l-1 6h-13.153v53h16.871c1.816 1.849 4.339 3 7.129 3zm-8-10c0-.423.043-.836.106-1.242l2.61-.699 1.284.584v2.713l-1.284.585-2.61-.699c-.063-.406-.106-.819-.106-1.242zm3.647 3.715 1.261-.574 2.092 1.394v1.051l-1.872 1.872c-.783-.303-1.509-.72-2.151-1.24zm4.353-6.513 2 1.333v2.93l-2 1.333-2-1.333v-2.93zm1 8.384v-1.051l2.092-1.395 1.261.574.671 2.503c-.642.52-1.368.938-2.151 1.24zm6.894-6.828c.063.406.106.819.106 1.242s-.043.836-.106 1.242l-2.61.699-1.284-.584v-2.713l1.284-.585zm-1.473 4.949.76-.204c-.165.337-.345.665-.554.973zm0-7.414.206-.769c.209.308.389.636.554.973zm-2.068-.008-1.261.574-2.092-1.394v-1.051l1.872-1.872c.783.303 1.509.72 2.151 1.24zm-4.353-3.699-.558-.558c.185-.013.37-.028.558-.028s.373.015.558.028zm-2.872-.044 1.872 1.872v1.051l-2.092 1.395-1.261-.574-.671-2.503c.643-.521 1.369-.938 2.152-1.241zm-3.755 2.982.206.769-.76.204c.165-.337.345-.665.554-.973zm.206 8.183-.206.769c-.209-.308-.389-.636-.554-.973zm5.863 4.265.558-.558.558.558c-.185.013-.37.028-.558.028s-.373-.015-.558-.028zm22.558-29.972h-15.08c-.488-3.387-3.401-6-6.92-6s-6.432 2.613-6.92 6h-6.932c.407-3.178 1.747-6.133 3.887-8.551l2.58 2.58.805-4.029h24.58v-12h4zm-26.899 0c.465-2.279 2.484-4 4.899-4s4.434 1.721 4.899 4zm9.798 2c-.465 2.279-2.484 4-4.899 4s-4.434-1.721-4.899-4zm-14.871-13.386 1.697-.339-.34 1.697zm1.819-16.614h16.307l1.666 10h-1.937l-1-8h-13.766l-1 8h-1.937zm14.02 10h-11.734l.75-6h10.234zm6.314 2-1-6h4.819v10h-22.18l.455-2.275-8.303 1.661.614.614h-2.586v-10h4.82l-1 6zm-30.181-6v12h6.586l.034.034c-2.513 2.802-4.07 6.252-4.492 9.966h-6.128v-22zm-4 49v-25h6.003c0 .024-.003.047-.003.071v1.929h2v-1.929c0-.024.003-.047.003-.071h7.076c.488 3.386 3.401 6 6.92 6s6.432-2.614 6.92-6h15.081v25h-13.353c.855-1.473 1.353-3.178 1.353-5 0-5.514-4.486-10-10-10s-10 4.486-10 10c0 1.822.498 3.527 1.353 5zm37-35c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3-1.346-3-3-3zm0 4c-.552 0-1-.449-1-1s.448-1 1-1 1 .449 1 1-.448 1-1 1zm-3.707 19.293 2.293-2.293-2.293-2.293 1.414-1.414 2.293 2.293 2.293-2.293 1.414 1.414-2.293 2.293 2.293 2.293-1.414 1.414-2.293-2.293-2.293 2.293zm-22.586-8.586-2.293 2.293 2.293 2.293-1.414 1.414-2.293-2.293-2.293 2.293-1.414-1.414 2.293-2.293-2.293-2.293 1.414-1.414 2.293 2.293 2.293-2.293z"
        fill="url(#SVGID_1_)"
      />
    </svg>
  </ImageHeader>
);

export default ImageHeaderComponent;
